import { REQUESTED_FEATURES, REQUEST_FEATURES_FAILED, RECEIVED_FEATURES } from '../actions/GetFeatures';
import { FEATURE_LIST_HIDDEN } from '../actions/HideFeatureList';
import { FEATURE_LIST_UNHIDDEN } from '../actions/ShowFeatureList';

const initialState = {
  loading: true,
  data: [],
  feature_list_hidden: false,
};

const features = (state = initialState, action) => {
  switch (action.type) {
    case REQUESTED_FEATURES:
      return initialState;
    case RECEIVED_FEATURES:
      return {
        loading: false,
        data: action.data.data,
        feature_list_hidden: action.data.feature_list_hidden,
      };
    case REQUEST_FEATURES_FAILED:
      return Object.assign({}, initialState, {
        loading: false,
      });
    case FEATURE_LIST_HIDDEN:
      return Object.assign({}, state, {
        feature_list_hidden: true,
      });
    case FEATURE_LIST_UNHIDDEN:
      return Object.assign({}, state, {
        feature_list_hidden: false,
      });
    default:
      return state;
  }
};

export default features;
